import { useCompoundBody, usePointToPointConstraint, useSphere } from "@react-three/cannon";
import { useRef } from "react";
import { Group, Mesh, SpotLight } from "three";
import { ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const light = useRef<SpotLight>(null);
  const [fixed] = useSphere(() => ({ args: [1], position: [0, 18, 0], type: 'Static' }), useRef<Mesh>(null));
  const [lamp] = useCompoundBody(() => ({
    angularDamping: 0.5,
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [2, 3, 0.8, 12], mass: 1, position: [0, 0, 0], type: 'Cylinder' },
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  usePointToPointConstraint(fixed, lamp, { pivotA: [0, 0, 0], pivotB: [0, 2, 0] });
  const bind = {}; // useDragConstraint(lamp);
  return (
    <mesh ref={lamp} {...bind}>
      <cylinderGeometry attach="geometry" args={[2, 3, 0.8, 12]} />
      <meshStandardMaterial attach="material" />
      <pointLight decay={5} intensity={10 * Math.PI} />
      <spotLight
        angle={0.4}
        decay={0}
        penumbra={1}
        position={[0, 20, 0]}
        ref={light}
        intensity={0.6 * Math.PI}
        castShadow
      />
    </mesh>
  );
};

// import { useCompoundBody } from "@react-three/cannon";
// import { useRef } from "react";
// import { Group } from "three";
// import { useDragConstraint, Box, Cylinder } from "../utils";

// export default () => {
//   const [ref] = useCompoundBody(() => ({
//     mass: 300,
//     position: [-10, -4, 8],
//     rotation: [0, Math.PI / 2, 0],
//     shapes: [
//       { args: [19, 0.75, 10], mass: 150, position: [0, 0.75, 0], type: 'Box' },

//       { args: [1.0, 0.75, 1.0], mass: 25, position: [-8, -0.75, -3.5], type: 'Box' },
//       { args: [1.0, 0.75, 1.0], mass: 25, position: [0, -0.75, -3.5], type: 'Box' },
//       { args: [1.0, 0.75, 1.0], mass: 25, position: [8, -0.75, -3.5], type: 'Box' },
//       { args: [1.0, 0.75, 1.0], mass: 25, position: [-8, -0.75, 3.5], type: 'Box' },
//       { args: [1.0, 0.75, 1.0], mass: 25, position: [0, -0.75, 3.5], type: 'Box' },
//       { args: [1.0, 0.75, 1.0], mass: 25, position: [8, -0.75, 3.5], type: 'Box' },
//     ], 
//     type: 'Dynamic'
//   }), useRef<Group>(null));
//   const bind = {}; // useDragConstraint(ref);
//   return (
//     <group ref={ref} {...bind}>
//       <Box position={[0, 0.75, 0]} args={[19, 1.5, 10]} />

//       <Cylinder position={[-8, -0.75, -3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
//       <Cylinder position={[0, -0.75, -3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
//       <Cylinder position={[8, -0.75, -3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
//       <Cylinder position={[-8, -0.75, 3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
//       <Cylinder position={[0, -0.75, 3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
//       <Cylinder position={[8, -0.75, 3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
//     </group>
//   );
// };

